var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "拒绝审核",
        visible: _vm.dialogVisible,
        width: "450px",
        "close-on-click-modal": false,
        "show-close": true,
        center: "",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "reject-dialog-content" },
        [
          _c("div", { staticClass: "warning-icon" }, [
            _c("i", { staticClass: "el-icon-warning-outline" }),
          ]),
          _c("div", { staticClass: "warning-message" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _c("el-input", {
            directives: [{ name: "no-emoji", rawName: "v-no-emoji" }],
            staticClass: "reject-reason",
            attrs: { type: "textarea", placeholder: "请输入拒绝原因", rows: 4 },
            model: {
              value: _vm.rejectReason,
              callback: function ($$v) {
                _vm.rejectReason = $$v
              },
              expression: "rejectReason",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handleConfirm } },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }